/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CaptureFeed/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import Error from './Error/index'
import Loading from './Loading/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function CaptureFeed({
  children,
  viewPath = "/DesignSystem/VideoCapture/Content/CaptureFeed",
  theme,
  preview,
  innerRef,
  handleClick,
  showOverlay
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Loading'}>
<Loading
  viewPath={`${viewPath}/Loading`}
 theme={theme}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Error'}>
<Error
  viewPath={`${viewPath}/Error`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 theme={theme}
 preview={preview}
 innerRef={innerRef}
 handleClick={handleClick}
 showOverlay={showOverlay}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}